export const getColorForGroup = (groupNumber, groupCount, opacity = 1) =>
  `hsla(${(groupNumber / groupCount) * 300}, 77%, 75%, ${opacity})`;
